import React from 'react';
import { Col, Form, Input, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const InfoSection = () => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Info')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Nome ruolo')} name='title'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(InfoSection);
